import _filter from 'lodash/filter';

export const DASHBOARD = {
	CRM: 'crm',
	MARKETING: 'marketing'
};

export const ERROR_SEVERITY = {
	WARNING: 'warning',
	ERROR: 'error'
};

export const BOOLEAN_OPTIONS = [
	{ id: true, label: 'True' },
	{ id: false, label: 'False' }
];

export const DEVICE_TYPES = [
	{ id: 'android', label: 'Android' },
	{ id: 'ios', label: 'IOS' }
];

export const UPDATE_TYPES = [
	{ id: 'NO_UPDATE', label: 'NO_UPDATE' },
	{ id: 'FORCE_UPDATE', label: 'FORCE_UPDATE' },
	{ id: 'SOFT_UPDATE', label: 'SOFT_UPDATE' }
];

export const GAME_NAME = [
	{ id: 'ludo', label: 'Ludo' },
	{ id: 'ninja', label: 'Ninja' },
	{ id: 'turbo', label: 'Turbo' },
	{ id: 'snl', label: 'SNL' },
	{ id: 'tc', label: 'Trump Cards' },
	{ id: 'carrom', label: 'Carrom' },
	{ id: 'zcm', label: 'Zupee Cricket Mania' },
	{ id: 'zkj', label: 'Zupee Cricketbaaz' },
	{ id: 'hc', label: 'Zupee Super Over' }
];

export const APP_ARCHS = [
	{ id: 'ARMV7', label: 'ARMV7' },
	{ id: 'ARMV8', label: 'ARMV8' }
];

export const SUB_APP_GAME_NAME = [
	{ id: 'SNLT', label: 'SNL' },
	{ id: 'TC', label: 'Trump Cards' },
	{ id: 'CARROM', label: 'Carrom' },
	{ id: 'ZKJ', label: 'Zupee Cricketbaaz' },
	{ id: 'HC', label: 'Zupee Super Over' }
];

export const APPS = [
	{
		displayName: 'Ludo Supreme Gold',
		appName: 'in.ludo.supremegold',
		isGold: true,
		websites: ['ludosupreme.com', 'zupee.com']
	},
	{
		displayName: 'Super App',
		appName: 'in.zupee.app',
		isGold: true,
		websites: ['zupee.com']
	},
	{
		displayName: 'Ludo Supreme',
		appName: 'in.ludo.supreme',
		isGold: false,
		websites: ['ludosupreme.com']
	},
	{
		displayName: 'Ludo Ninja Gold',
		appName: 'in.ludo.ninjagold',
		isGold: true,
		websites: ['ludoninja.com']
	},
	{
		displayName: 'Ludo Ninja',
		appName: 'in.ludo.ninja',
		isGold: false,
		websites: ['ludoninja.com']
	},

	{
		displayName: 'SNL Plus',
		appName: 'in.snl.plus',
		isGold: false,
		websites: ['snakesandladdersplus.com']
	},
	{
		displayName: 'SNL Plus Gold',
		appName: 'in.snl.plusgold',
		isGold: true,
		websites: ['snakesandladdersplus.com']
	},
	{
		displayName: 'Choco Crush',
		appName: 'in.crush.chocogold',
		isGold: true,
		websites: ['chococrush.com']
	},
	{
		displayName: 'SNL Plus',
		appName: 'in.snl.plus',
		isGold: false,
		website: 'https://www.snakesandladdersplus.com'
	},
	{
		displayName: 'SNL Plus Gold',
		appName: 'in.snl.plusgold',
		isGold: true,
		website: 'https://www.snakesandladdersplus.com'
	},
	{
		displayName: 'Choco Crush',
		appName: 'in.crush.chocogold',
		isGold: true,
		website: 'https://chococrush.com/'
	},
	{
		displayName: 'Zupee Lite',
		appName: 'com.zupee.free',
		isGold: true,
		website: 'https://play.google.com/store/apps/details?id=com.zupee.free&hl=en-IN'
	}
];

export const CRM_APPS = [
	{
		displayName: 'Ludo Supreme Gold',
		appName: 'in.ludo.supremegold',
		isGold: true,
		website: 'https://www.ludosupreme.com/'
	}
];

// Placeholder are replaced by docker-entrypoint.sh as per environment
export const CURRENT_ENV = '__REACT_APP_NODE_ENV__';

export const LUDO_SUPREME_DOMAIN = '.ludosupreme.com';

export const ASSET_OPTIONS = [
	{ id: 'website', label: 'Website' },
	{ id: 'app', label: 'App' }
];

export const IMAGE_TYPES = [
	{ id: 'jpeg', label: 'JPEG' },
	{ id: 'webp', label: 'WEBP' },
	{ id: 'jpg', label: 'JPG' },
	{ id: 'png', label: 'PNG' }
];

export const WEB_ASSETS = [
	{ id: 'logo', label: 'Logo' },
	{ id: 'icon', label: 'Icon' },
	{ id: 'image', label: 'Image' },
	{ id: 'game', label: 'Game' },
	{ id: 'custom', label: 'Custom' }
];

export const APP_ASSETS = [
	{ id: 'notice', label: 'Notice' },
	{ id: 'content', label: 'Content' },
	{ id: 'banner', label: 'Banner' },
	{ id: 'meme', label: 'Meme' },
	{ id: 'story', label: 'Story' },
	{ id: 'icon', label: 'Icon' },
	{ id: 'custom', label: 'Custom' }
];

export const GOLD_APPS = _filter(APPS, (app) => app.isGold);

export enum BOOLEAN_VALUES {
	TRUE = 'true',
	FALSE = 'false'
}

export enum CASE {
	UPPERCASE,
	LOWERCASE,
	NOCASE
}

export enum ETournamentCsvStatus {
	APPROVED = 'APPROVED',
	WAITING = 'WAITING',
	FAILED = 'FAILED',
	SUCCESS = 'SUCCESS'
}

export enum EQuestionBankCsvStatus {
	APPROVED = 'APPROVED',
	WAITING = 'WAITING',
	FAILED = 'FAILED',
	SUCCESS = 'SUCCESS'
}

export enum ECOLOR {
	GREEN = 'green',
	RED = 'red'
}

export const enum ALERT_TYPES {
	SUCCESS = 'success'
}

export enum EApiResponseCode {
	SUCCESS = 200
}

export const STATUS_COLORS = new Map<string, string>([
	['processing', '#ff6600'],
	['failed', '#EE4443'],
	['completed', '#008000']
]);

export const BACK_BTN_LABEL: string = 'Back';
export const SUBMIT_BTN_LABEL: string = 'Submit';

export enum EHttpStatus {
	CODE_200 = 200,
	CODE_500 = 500,
	CODE_422 = 422
}

export const OUTPUT_IMAGE_FORMAT_LABEL: string =
	"[Optional] Select Image Format (If not selected uploaded image's format will be used)";

export const IMAGE_RESIZING_WITDH_LABEL: string = '[Optional] For Example, If resizing image to 1920x1080 add width as 1920 here';

export const IMAGE_RESIZING_HEIGHT_LABEL: string = '[Optional] For Example, If resizing image to 1920x1080 add heigth as 1080 here';

export const ASSET_LINK_LABEL: string = 'Asset Link';

export const CSV_LINK_LABEL: string = 'CSV Link';

export const NONE_LABEL: string = 'none';

export const EMPTY_ARRAY = Object.freeze([]);

export const EMPTY_OBJECT = Object.freeze({});

export const EMPTY_STRING = Object.freeze('');

export const EMPTY_NUMBER = Object.freeze(0);

export const EMPTY_MAP = Object.freeze(new Map());

export enum EAPKArchs {
	ARMV7 = 'ARMV7',
	ARMV8 = 'ARMV8'
}

export const WHITE: string = 'white';

export const BLACK: string = 'black';

export const LIGHT_CORAL: string = 'lightcoral';

export const LIGHT_GREEN: string = 'lightgreen';

export const USER_DETAILS_PATH: string = '/getUserDetails';

export const APPLICATION_JSON: string = 'application/json';

export const GAME_NAMES = {
	LUDO: 'LUDO',
	NINJA: 'NINJA',
	TURBO: 'TURBO',
	SNLT: 'SNLT',
	CARROM: 'CARROM',
	CC: 'CC',
	TC: 'TC',
	QUIZ: 'QUIZ',
	LUDONX: 'LUDONX',
	CT: 'CT',
	SUPERAPP: 'SUPERAPP',
	TCNX: 'TCNX	',
	ZKJ: 'ZKJ',
	HC: 'HC'
};

export interface Apk {
	_id?: String;
	versionNumber: number;
	apkLinkUrl: string;
	appPackageName: string;
	versionName: string;
	updatedAt?: number;
	updatedBy?: string;
	deployedOnWebsite?: boolean;
	gameName?: string;
	architecture?: EAPKArchs;
}

export const EBooleanStatus = {
	YES: 'YES',
	NO: 'NO'
};

export const BUTTON_LABELS = {
	AGREE: 'Submit',
	DISAGREE: 'Cancel'
};

export const ERROR_MESSAGES = {
	IMAGE_SIZE_ERROR_MESSAGE: 'Image size is greater than 100kb',
	GIF_SIZE_ERROR_MESSAGE: 'Gif size is greater than 200kb',
	S3_ASSET_PRESENT_MESSAGE: 'Asset already exists on this path'
};

export const MERCHANT_TYPES = {
	ZUPEE: 'ZUPEE',
	EXTERNAL: 'EXTERNAL',
	MARKETING: 'MARKETING'
} as const;

export const ENVIRONMENT = {
	STAGING: 'staging',
	PRODUCTION: 'production',
	QA: 'qa'
};

export const LUDO_PROD_HEADER_STYLE = {
	backgroundColor: '#ffe800',
	color: '#4611a7',
	fontWeight: 'bold'
};

export const LUDO_STAGE_HEADER_STYLE = {
	backgroundColor: '#4a90e2',
	color: '#FFFFFF',
	fontWeight: 'bold'
};

export const ACL_ENDPOINTS: string[] = [
	'/auth/unauthenticated/getACLUsers',
	'/auth/unauthenticated/login',
	'/auth/unauthenticated/outsourceLogin',
	'/dashboard/unauthorized',
	'/dashboard/unauthorised',
	'/dashboard/forward',
	'/dashboard/inGameRewardsEventSupersix',
	'/dashboard/listMatchSupersix',
	'/dashboard/talkzyData',
	'/dashboard/mandateRefund',
	'/dashboard/getPaymentPGFailureList',
	'/dashboard/getAllPaymentGatewayList',
	'/dashboard/updatePaymentPGFailureData',
	'/dashboard/getTDSAbsorptionActiveOffers',
	'/dashboard/createTDSAbsorptionOffers',
	'/dashboard/activateTDSAbsorptionOffers',
	'/dashboard/updateTDSAbsorptionOffers',
	'/dashboard/disableTDSAbsorptionOffers',
	'/dashboard/updateTDSAbsorptionConfig',
	'/dashboard/getTDSAbsorptionConfig',
	'/dashboard/listHelpdeskTickets',
	'/dashboard/callUser',
	'/dashboard/getCampaigns',
	'/dashboard/createHelpdeskTicket',
	'/dashboard/getReferralsSummary',
	'/dashboard/getActiveCouponForUser',
	'/dashboard/uploadCampaignDataCsv',
	'/dashboard/getDefaultValueForKey',
	'/dashboard/updateZkKeyPartially',
	'/dashboard/promoteToProdDirectly',
	'/dashboard/uploadCsvForLotteryDashboard',
	'/dashboard/performSelectedAction',
	'/dashboard/getDynamicSwitcherPayoutConfig',
	'/dashboard/addNewPaymentGatewayInDynamicSwitcher',
	'/dashboard/updateDynamicSwitcherPayoutConfig',
	'/dashboard/updateBonusMoneyLambdaRequestStatus',
	'/dashboard/listBonusMoneyLambdaRequest',
	'/dashboard/listAthenaCrudRequest',
	'/dashboard/createAthenaCrudRequest',
	'/dashboard/rejectAthenaCrudRequest',
	'/dashboard/approveAthenaCrudRequest',
	'/dashboard/getAthenaCrudRequestDetails',
	'/dashboard/updateAthenaCrudRequest',
	'/dashboard/getAthenaCrudRequestVersionHistory',
	'/dashboard/activatePayoutRecord',
	'/dashboard/getDowntimeManagementConfig',
	'/dashboard/updateDowntimeManagementConfig',
	'/dashboard/getLotteryWinnerData',
	'/dashboard/getInternalUserList',
	'/dashboard/addInternalUser',
	'/dashboard/updateInternalUser'
];
export const NA_VALUE: string = 'N/A';
export const BULK_REFUND_CSV_REQUIRED_HEADERS = ['zupeeUserId', 'ltid', 'freshdeskTicketId'];
export const BULK_REFUND_CSV_LABEL: string = 'Upload Bulk Refund CSV File';